import { combineReducers } from 'redux';
import { INITIAL_STATE, KONTRAK_GET_LOADING, KONTRAK_GET_SUCCESS, KONTRAK_GET_ERROR, KONTRAK_SAVE_LOADING, KONTRAK_SAVE_SUCCESS, KONTRAK_SAVE_ERROR, KONTRAK_UPDATE_LOADING, KONTRAK_UPDATE_SUCCESS, KONTRAK_UPDATE_ERROR, KONTRAK_DELETE_LOADING, KONTRAK_DELETE_SUCCESS, KONTRAK_DELETE_ERROR, KONTRAK_LIST_LOADING, KONTRAK_LIST_SUCCESS, KONTRAK_LIST_ERROR } from './actions';

const kontrakGet = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case KONTRAK_GET_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_GET_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_GET_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const kontrakSave = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case KONTRAK_SAVE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_SAVE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_SAVE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const kontrakUpdate = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case KONTRAK_UPDATE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_UPDATE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_UPDATE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const kontrakDelete = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case KONTRAK_DELETE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_DELETE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_DELETE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const kontrakList = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case KONTRAK_LIST_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_LIST_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case KONTRAK_LIST_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}


const kontrakReducer = combineReducers({
    data: kontrakGet,
    save: kontrakSave,
    update: kontrakUpdate,
    delete: kontrakDelete,
    list: kontrakList
})

export default kontrakReducer;